import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import { CTA } from '../components/Layout/CTA';

import '../components/GlobalStyle.css';
import '../components/Backgrounds/Backgrounds.css'

import SupportSplash from '../assets/images/Support Services - Splash.png';
import Accounting from '../assets/images/Support Services - World Class.png';
import CircleBG3 from '../assets/images/Circle BG 3.png';

import { FadeLoad, FadeScroll, FadeLoadDelay } from '../components/styled/Motion.styled';
import { QuotationMark, QuoteSection } from '../components/styled/BPSQuotes';

const ImageMargin = styled.div`
    @media screen and (min-width: 1200px) {
        z-index: -1;
        width: 60%;
        margin: -8rem auto auto;
    }
`


const SupportServices = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Products & Services | Support Services</title>
                <link rel="canonical" href="https://bestpayment.solutions/support-services" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75'>
                <Row className='pt-5 justify-content-evenly align-items-center text-center text-md-start'>
                    <Col xxl={5} md={6}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Customer Support Services</h2>
                            <h1 className='fs-60'>
                                Program support for your entire journey
                            </h1>
                            <p className='pt-4'>
                                We have a dedicated team to support every aspect of your incentive program. From customer service, to accounting, to account management, we are here to make your program a success!
                            </p>
                        </FadeLoad>
                    </Col>
                    <Col md={5}>
                        <FadeLoadDelay>
                            <img src={SupportSplash} width='100%' />
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5'>
                <Row className="justify-content-center align-items-center text-center py-5">
                    <Col lg={6}>
                        <h3 className='fs-48'>
                            Customer service that genuinely cares
                        </h3>
                        <p>
                            You won’t find a more dedicated customer service team anywhere. At Best Payment Solutions, we know customer service is our frontline. Our customer service representatives are hands-on, and will be the first to spot potential issues and bring them to our attention. This results in immediate resolution. Our customer service team trains to understand every aspect of our clients' programs. With this continuous training, you are provided with expert answers and the best possible solutions. When someone reaches out, they can be confident that our team genuinely cares and will do whatever they can to help.
                        </p>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-50 bg-sky-tint-3 py-5'>
                <Row className='justify-content-center'>
                    <Col lg={5}>
                        <FadeScroll>
                            <QuoteSection>
                                <QuotationMark />
                                “I hope that, after talking to our team, people feel that a weight has been lifted off their shoulders. I hope that we can be the resolution for them. And I hope that they get the sense that if they ever do have any future questions or anything that they can come to us."
                                <div className='pt-4'>
                                    Maryah B.
                                </div>
                                <div>
                                    Customer Service Manager
                                </div>
                            </QuoteSection>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={5} sm={8}>
                        <FadeScroll>
                            <img src={Accounting} width='100%' />
                        </FadeScroll>
                    </Col>
                    <Col lg={4}>
                        <h3 className='fs-48'>World class accounting</h3>
                        <p>
                            With decades of experience, our accounting department is excellent in every way. From billing, to ACH transactions, to payment processing, to invoicing, you can rely on us. We take pride in providing transparent, reliable, and efficient service to all our clients.
                        </p>
                    </Col>
                    <Col className='pt-4 d-lg-none'>
                        <h3 className='fs-48'>Account managers with holistic mindsets</h3>
                        <p>
                            When you partner with Best Payment Solutions, we assign you a dedicated account manager. Your account manager will be there to answer your questions, provide regular updates, and quickly resolve any issues.  With Best Payment Solutions, you get an account manager who has a deep understanding of every aspect of your program and the processes that make it successful. They are proactive partners, looking at all the pieces in play. This allows them to pinpoint what is needed before you need it and make sure your goals are met if not exceeded.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5 d-none d-lg-block circle-bg-5-scroll'>
                <Row className="align-items-center py-5">
                    <Col lg={4} className='offset-1'>
                        <h3 className='fs-48'>Account managers with holistic mindsets</h3>
                        <p>
                            When you partner with Best Payment Solutions, we assign you a dedicated account manager. Your account manager will be there to answer your questions, provide regular updates, and quickly resolve any issues.  With Best Payment Solutions, you get an account manager who has a deep understanding of every aspect of your program and the processes that make it successful. They are proactive partners, looking at all the pieces in play. This allows them to pinpoint what is needed before you need it and make sure your goals are met if not exceeded.
                        </p>
                    </Col>
                </Row>
            </Container><Container fluid className='vh-50 bg-sky-tint-3 py-5'>
                <Row className='justify-content-center'>
                    <Col lg={5}>
                        <FadeScroll>
                            <QuoteSection>
                                <QuotationMark />
                                “I think of clients as teammates. It's a collaboration. So it's just that close relationship, understanding that we had the same goal. We're working together, and they can rely on us to pay attention to their needs."
                                <div className='pt-4'>
                                    Cedric R.
                                </div>
                                <div>
                                    Director of Account Management
                                </div>
                            </QuoteSection>
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='py-5'>
                <CTA />
            </Container>
            <Footer />
        </>
    );
}

export default SupportServices;